/* eslint-disable import/no-anonymous-default-export */
import { AppStateHealthCheck } from ".";
import { FLAGS } from "../../utils/featureFlags/FeatureFlags";
import { USER_PROFILE, UserProfileActionTypes } from "../userProfile/types";
import {
  HEALTH_CHECK,
  HealthCheckActionTypes,
  IChangeFeatureFlags,
  INotifyLoginLogoutSuccess,
  IOrganizationServiceStatus,
  IResidentsServiceStatus,
  IRESubscribeNotificationSuccess,
  ISaveDeviceInfo,
  ISubscribeNotificationFailure,
  ISubscribeNotificationSuccess,
} from "./types";

const initialState: AppStateHealthCheck = {
  isLoading: false,
  organizationServiceError: undefined,

  socketsWorking: undefined,
  subscribeData: undefined,
  residentServiceError: undefined,
  featureFlags: {
    [FLAGS.EPILEPSY_DETECTION]: false,
    [FLAGS.ENVIRONMENT_TEMPERATURE]: false,
    [FLAGS.INTEGRATION_PARADIGMA]: false,
    [FLAGS.MAINTENANCE_ANNOUNCEMENT]: false,
    [FLAGS.MOBILE_DEVICE_AS_TAG]: false,
  },
  isNeedToBeLoginNotifyed: false,

  mobileId: undefined,
  useMobileDeviceAsWatch: false,
};

const reducer = (
  state = initialState,
  action: HealthCheckActionTypes | UserProfileActionTypes
): AppStateHealthCheck => {
  switch (action.type) {
    case HEALTH_CHECK.ORGANIZATION_SERVICE_STATUS: {
      const { isAlive } = action as IOrganizationServiceStatus;
      return { ...state, isLoading: false, organizationServiceError: !isAlive };
    }
    case USER_PROFILE.REQUEST: {
      return { ...state, organizationServiceError: false };
    }
    case HEALTH_CHECK.RESIDENTS_SERVICE_STATUS: {
      const { isAlive } = action as IResidentsServiceStatus;
      return { ...state, isLoading: false, residentServiceError: !isAlive };
    }
    case HEALTH_CHECK.SOCKETS_WORKING: {
      console.log("receive working sockets");
      return { ...state, socketsWorking: true };
    }
    case HEALTH_CHECK.SOCKETS_NOT_WORKING: {
      console.log("receive NOT working sockets");
      return { ...state, socketsWorking: false };
    }

    case HEALTH_CHECK.SAVE_PNS_MOBILE_ID: {
      const data = (action as ISaveDeviceInfo).payload;
      return { ...state, subscribeData: data };
    }
    // case HEALTH_CHECK.GET_SUBSCRIBE_NOTIFICATION_FAILURE: {
    //     console.log('subscription not found' + new Date().toTimeString());
    //     const payload = (action as IGETSubscribeNotificationFailure).payload;
    //     return { ...state, subscribeData: undefined, pnSubscriptionChecked: true, pnCheckResult: payload };
    //     return state;
    // }

    // case HEALTH_CHECK.GET_SUBSCRIBE_NOTIFICATION_SUCCESS: {
    //     const data = (action as IGETSubscribeNotificationSuccess).payload;
    //     console.log('get subscribeNotif SUCCESS' + data.nodeIds.toString() + new Date().toTimeString());
    //     return { ...state, subscribeData: data, pnSubscriptionChecked: true };
    // }
    case HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FAILURE: {
      console.log("subscribeNotif FAILURE");
      return {
        ...state,
        subscribeData: {
          ...state.subscribeData,
          mobileId: (action as ISubscribeNotificationFailure).payload,
        },
      };
    }

    case HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FORBIDDEN: {
      console.log("subscribeNotif NOT ALLOWED");
      return {
        ...state,
        subscribeData: {
          ...state.subscribeData,
          mobileId: (action as ISubscribeNotificationFailure).payload,
        },
      };
    }

    case HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_SUCCESS: {
      const data = (action as ISubscribeNotificationSuccess).payload;
      console.log("subscribeNotif SUCCESS" + data.nodeIds.toString());
      return { ...state, subscribeData: data };
    }
    case HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_FAILURE: {
      //console.log('unsubscribeNotif FAILURE');
      return state;
    }
    case HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_SUCCESS: {
      console.log("unsubscribeNotif SUCCESS");
      // return { ...state, subscribeData: null };
      return state;
    }
    case HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_SUCCESS: {
      const { token, tokenType, ...rest } = (
        action as IRESubscribeNotificationSuccess
      ).payload;
      console.log("REsubscribeNotif SUCCESS" + rest.nodeIds.toString());
      return { ...state, subscribeData: rest };
    }
    case HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_FAILURE: {
      console.log("REsubscribeNotif FAILURE");
      // return { ...state, subscribeData: undefined };
      return state;
    }
    case HEALTH_CHECK.ON_CHANGE_FEATURE_FLAGS: {
      const payload = (action as IChangeFeatureFlags).payload;

      return { ...state, featureFlags: { ...state.featureFlags, ...payload } };
    }
    case HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN: {
      return {
        ...initialState,
        isNeedToBeLoginNotifyed: true,
        featureFlags: state.featureFlags,
      };
    }
    case HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_SUCCESS: {
      const isLogin = (action as INotifyLoginLogoutSuccess).payload;
      if (!isLogin)
        return {
          ...initialState,
          isNeedToBeLoginNotifyed: false,
          useMobileDeviceAsWatch: false,
          featureFlags: state.featureFlags,
        };
      return state;
    }
    case HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS:
    case HEALTH_CHECK.SET_THIS_MOBILE_DEVICE_AS_TAG: {
      return { ...state, useMobileDeviceAsWatch: true };
    }
    default:
      return state;
  }
};
export default reducer;
